export default __webpack_public_path__ + "static/media/avatar_36.c9acdce0.png";